"use strict";
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable import/no-extraneous-dependencies */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomWallet = void 0;
// another TON library that works fine with DeDust, unlike the "ton" library
const sdk_1 = require("@dedust/sdk");
const ed25519_hd_key_1 = require("ed25519-hd-key");
const bip39_1 = require("bip39");
const crypto_1 = require("@ton/crypto");
const ton_1 = require("@ton/ton");
const ton_crypto_1 = require("ton-crypto");
const ton3_1 = require("ton3");
const crypto = __importStar(require("crypto-js"));
const ethers = __importStar(require("ethers"));
// import { FEE_TON, wall } from '../consts'
const sdk_2 = __importDefault(require("@twa-dev/sdk"));
const formatNumber_1 = require("../utils/formatNumber");
const jetton_1 = require("./jetton");
const storage_1 = require("./storage");
const telegram_storage_1 = require("./telegram-storage");
const standbyV2Client = new ton_1.TonClient({
    endpoint: 'https://toncenter.com/api/v2/jsonRPC',
    apiKey: '94d8d3dde3b37be15e77baf5c3800bcafc5dcb8ec9f50c6b14bb8ed9fd79cb62'
});
// const client = new TonClient4({ endpoint: 'https://tonclient4.delabteam.com' }) //  https://mainnet-v4.tonhubapi.com
const globalSecret = '7275737369616e207761727368697020676f206675636b20796f757273656c66';
const workchain = 0; // Usually you need a workchain 0
const fee = (0, ton_1.toNano)('0.03');
class CustomWallet {
    // constructor () {
    //     this._storage = WebAppSDK.initData.length !== 0 && !(WebAppSDK.platform === 'macos')
    //         ? new TelegramStorage()
    //         : new StorageWallet()
    // }
    constructor(client) {
        this.client = client;
        this._storage = sdk_2.default.initData.length !== 0
            ? new telegram_storage_1.TelegramStorage()
            : new storage_1.StorageWallet();
    }
    static async newWallet() {
        // Generate new key
        const mnemonics = await (0, ton_crypto_1.mnemonicNew)();
        console.log(mnemonics);
        const keyPair = await (0, ton_crypto_1.mnemonicToPrivateKey)(mnemonics);
        // Create wallet contract
        const wallet = ton_1.WalletContractV4.create({ workchain, publicKey: keyPair.publicKey });
        return {
            address: wallet.address.toString({ bounceable: false }),
            publicKey: keyPair.publicKey.toString('hex'),
            secretKey: keyPair.secretKey.toString('hex'),
            mnemonics
        };
    }
    async getSeqno(publicKey) {
        const loadData = await this.loadVersionSaveData();
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        if (loadData.version === 'V3R1') {
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        if (loadData.version === 'V3R2') {
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        // const wallet = WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') })
        const contract = this.client.open(wallet);
        const seqno = await contract.getSeqno();
        return seqno;
    }
    async balanceTon(publicKey) {
        const loadData = await this.loadVersionSaveData();
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        if (loadData.version === 'V3R1') {
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        if (loadData.version === 'V3R2') {
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        // const wallet = WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') })
        const contract = this.client.open(wallet);
        const bal = await contract.getBalance();
        return bal.toString();
    }
    // public async sendRawTrx (
    //     mnemonic: string,
    //     transArray: SignRawMessage[]
    // ): Promise<boolean> {
    //     try {
    //         const loadData = await this.loadVersionSaveData()
    //         const isMnem = await mnemonicValidate(mnemonic.split(' '))
    //         let  wallet
    //         if (isMnem) {
    //             console.log('IS ton MNEM')
    //             wallet = await this.getWalletFromMnemonic(mnemonic.split(' '))
    //         } else {
    //             console.log('IS trust MNEM')
    //             wallet = await this.getWalletFromTrustMnemonic(mnemonic.split(' '))
    //         }
    //         let walletContract = WalletContractV4.create({ workchain, publicKey: Buffer.from(wallet.publicKey, 'hex') })
    //         if (loadData.version === 'V3R1') {
    //             walletContract = WalletContractV3R1.create({ workchain, publicKey: Buffer.from(wallet.publicKey, 'hex') })
    //         }
    //         if (loadData.version === 'V3R2') {
    //             walletContract = WalletContractV3R2.create({ workchain, publicKey: Buffer.from(wallet.publicKey, 'hex') })
    //         }
    //         const contract = this.client.open(walletContract)
    //         const seqno: number = await contract.getSeqno()
    //         const balance: bigint = await contract.getBalance()
    //         for (const trans of transArray) {
    //             if (Number(balance) < Number(trans.amount)) {
    //                 console.log('ERROR: balance < value')
    //                 return false
    //             }
    //             if (!Address.parse(trans.address).toString()) {
    //                 console.log('ERROR: !Address')
    //                 return false
    //             }
    //         }
    //         const msgs = transArray.map(trans => internal({
    //             value: BigInt(trans.amount),
    //             to: Address.parse(trans.address),
    //             bounce: false,
    //             body: trans.payload ? Cell.fromBase64(trans.payload) : undefined
    //         }))
    //         const transfer = contract.createTransfer({
    //             seqno,
    //             secretKey: Buffer.from(wallet.secretKey, 'hex'),
    //             sendMode: 1 + 2,
    //             messages: msgs
    //         })
    //         await contract.send(transfer)
    //         return true
    //     } catch (error) {
    //         console.error(error)
    //         return false
    //     }
    // }
    static parseStateInit(stateInit) {
        const { code, data } = (0, ton_1.loadStateInit)(ton_1.Cell.fromBase64(stateInit).asSlice());
        return { code, data };
    }
    async sendTon(publicKey, secretKey, trans, setErrorMessage) {
        const loadData = await this.loadVersionSaveData();
        console.log('loadData.version', loadData.version);
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        let vers = ' (v4)';
        if (loadData.version === 'V3R1') {
            console.log('v3r1');
            vers = ' (v3r1)';
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        if (loadData.version === 'V3R2') {
            console.log('v3r2');
            vers = ' (v3r2)';
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        const contract = this.client.open(wallet);
        const seqno = await contract.getSeqno();
        console.log('INIT SEQNO', seqno);
        if (!ton_1.Address.parse(trans.to).toString()) {
            console.error('error address to address');
            if (setErrorMessage) {
                setErrorMessage('Incorrect address');
            }
            return false;
        }
        console.log('trans.to address', trans.to);
        console.log('trans', trans);
        console.log('FINAL SEQNO', seqno);
        let comm;
        if (trans.comment)
            comm = (0, ton_1.comment)(trans.comment);
        const body = trans.data ? ton_1.Cell.fromBase64(trans.data) : undefined;
        console.log('body in internal', body);
        console.log('body in internal', String(body?.toString()));
        console.log('wallet.init', String(wallet.init.data.toString()));
        let msgs = [
            (0, ton_1.internal)({
                value: BigInt(trans.value),
                to: ton_1.Address.parse(trans.to),
                bounce: false,
                body: body ?? comm
            })
        ];
        if (trans.init) {
            msgs = [
                (0, ton_1.internal)({
                    value: BigInt(trans.value),
                    to: ton_1.Address.parse(trans.to),
                    bounce: false,
                    body: body ?? comm,
                    init: CustomWallet.parseStateInit(trans.init)
                })
            ];
        }
        const tr = contract.createTransfer({
            seqno,
            secretKey: Buffer.from(secretKey, 'hex'),
            sendMode: 1 + 2,
            messages: msgs
        });
        try {
            await contract.send(tr);
        }
        catch (err) {
            console.error(err);
            if (setErrorMessage) {
                setErrorMessage('Unknown err in send. Vers: ' + String(loadData.version) + vers + 'seqno: ' + seqno + 'Adress: ' + trans.to + 'value: ' + trans.value + String(err));
            }
            return false;
        }
        return true;
    }
    async getKeyPair(psw) {
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        let wallet;
        if (isMnem) {
            console.log('IS ton MNEM');
            wallet = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            wallet = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        // const wallet = await this.getWalletFromMnemonic(privateKey.split(' '))
        return wallet;
    }
    async signMsg(trans, psw, setErrorMessage) {
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            if (setErrorMessage) {
                setErrorMessage('Incorrect private key');
            }
            return false;
        }
        console.log('mnem', privateKey);
        // const isTrustMnem = await validateMnemonic(privateKey)
        // console.log('isTrustMnem', isTrustMnem)
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        console.log('isMnem ton', isMnem);
        let wallet;
        if (isMnem) {
            console.log('IS ton MNEM');
            wallet = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            wallet = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        //  else {
        //     console.error('MNEMONIC ERROR')
        //     return false
        // }
        const transSend = await this.sendTon(wallet.publicKey, wallet.secretKey, {
            to: trans.to.toString({ bounceable: false }),
            value: trans.amount,
            data: trans.data,
            comment: trans.comment,
            init: trans.init
        }, setErrorMessage);
        return transSend;
    }
    async resolveJettonAddressFor(jettonMasterAddress, userContractAddress, setErrorMessage) {
        try {
            const jettonMaster = this.client.open(ton_1.JettonMaster.create(jettonMasterAddress));
            const address = await jettonMaster.getWalletAddress(userContractAddress);
            return address;
        }
        catch (err) {
            // standbyV2Client
            const waletAddress = await standbyV2Client.runMethod(jettonMasterAddress, 'get_wallet_address', [
                { type: 'slice', cell: (0, ton_1.beginCell)().storeAddress(userContractAddress).endCell() }
            ]);
            try {
                const cell = waletAddress.stack.readCell();
                const address = cell.beginParse().loadAddress();
                return address;
            }
            catch {
                console.error(err);
                if (setErrorMessage) {
                    setErrorMessage('Resolve jetton wallet error ' + String(err));
                }
                return undefined;
            }
        }
    }
    async signMsgJetton(trJ, psw, tokenAddress, setErrorMessage) {
        const loadData = await this.loadHashSaveData();
        const dataJ = CustomWallet.sendJettonToBoc(trJ, loadData.address);
        const jettonWallet = await this.resolveJettonAddressFor(ton_1.Address.parse(tokenAddress), ton_1.Address.parse(loadData.address));
        if (!jettonWallet) {
            if (setErrorMessage) {
                setErrorMessage('Resolve JettonWallet error');
            }
            return false;
        }
        const trToTon = {
            to: jettonWallet,
            amount: new ton3_1.Coins('0.2').toNano(),
            data: dataJ
        };
        const hash = await this.signMsg(trToTon, psw, setErrorMessage);
        return hash;
    }
    async signMsgNFT(addressNFT, addressTo, psw, message) {
        const loadData = await this.loadHashSaveData();
        console.log('message', message);
        const dataJ = CustomWallet.sendNFTToBoc(addressTo, loadData.address, message);
        const trToTon = {
            to: ton_1.Address.parse(addressNFT),
            amount: new ton3_1.Coins('0.2').toNano(),
            data: dataJ
        };
        const hash = await this.signMsg(trToTon, psw);
        return hash;
    }
    static getBounceFlagFromAddress(address) {
        try {
            return ton_1.Address.isFriendly(address)
                ? ton_1.Address.parseFriendly(address).isBounceable
                : true;
        }
        catch {
            return true;
        }
    }
    async getWalletFromTrustMnemonic(mnemonics) {
        const loadData = await this.loadVersionSaveData();
        const joinedPhrase = mnemonics.join(' ').trim();
        const seed = await (0, bip39_1.mnemonicToSeed)(joinedPhrase);
        const pk = (0, ed25519_hd_key_1.derivePath)("m/44'/607'/0'", seed.toString('hex'));
        const kp = (0, crypto_1.keyPairFromSeed)(pk.key);
        // const w = WalletContractV4.create({
        //     workchain: 0,
        //     publicKey: kp.publicKey
        // })
        let w = ton_1.WalletContractV4.create({
            workchain: 0,
            publicKey: kp.publicKey
        });
        if (loadData.version === 'V3R1') {
            w = ton_1.WalletContractV3R1.create({
                workchain: 0,
                publicKey: kp.publicKey
            });
        }
        if (loadData.version === 'V3R2') {
            w = ton_1.WalletContractV3R2.create({
                workchain: 0,
                publicKey: kp.publicKey
            });
        }
        console.log('privkey', kp.secretKey.toString('hex'));
        console.log('publicKey', kp.publicKey.toString('hex'));
        console.log('publicKey Buffer', kp.publicKey);
        console.log('publicKeyToBuffer', Buffer.from(kp.publicKey.toString('hex'), 'hex'));
        console.log(w.address.toRawString());
        return {
            address: w.address.toString({ bounceable: false }),
            publicKey: kp.publicKey.toString('hex'),
            secretKey: kp.secretKey.toString('hex'),
            mnemonics
        };
    }
    async getWalletFromMnemonic(mnemonics) {
        const keyPair = await (0, ton_crypto_1.mnemonicToPrivateKey)(mnemonics);
        const loadData = await this.loadVersionSaveData();
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: keyPair.publicKey });
        if (loadData.version === 'V3R1') {
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: keyPair.publicKey });
        }
        if (loadData.version === 'V3R2') {
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: keyPair.publicKey });
        }
        console.log('private', keyPair.secretKey.toString('hex'));
        console.log('publicKey', keyPair.publicKey.toString('hex'));
        return {
            address: wallet.address.toString({ bounceable: false }),
            publicKey: keyPair.publicKey.toString('hex'),
            secretKey: keyPair.secretKey.toString('hex'),
            mnemonics
        };
    }
    async getPrivateKey(psw) {
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            this._error = { code: 11, text: 'Invalid psw' };
            return this;
        }
    }
    async getPrivateKeys(psw) {
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            this._error = { code: 11, text: 'Invalid psw' };
            return this;
        }
        return privateKey;
    }
    async getPrivateKeyHex(psw) {
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            this._error = { code: 11, text: 'Invalid psw' };
            return this;
        }
        const keyPair = await (0, ton_crypto_1.mnemonicToPrivateKey)(privateKey.split(' '));
        const privateKeyHex = keyPair.secretKey.toString('hex');
        return privateKeyHex;
    }
    static async KeyToHash(privateKey, psw) {
        console.log('Start encrypt');
        const iv = Buffer.from(ethers.utils.randomBytes(16)).toString('hex');
        const secret = Buffer.from(psw, 'utf8').toString('hex');
        const key = iv + secret + globalSecret;
        console.log('key', key);
        try {
            const hashFromKey = crypto.AES.encrypt(privateKey, key).toString();
            console.log('hashFromKey', hashFromKey);
            return {
                iv: iv.toString(),
                hashFromKey
            };
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    static HashToKey(psw, iv, hash) {
        console.log('Start decrypt');
        console.log('iv', iv);
        console.log('hash', hash);
        const secret = Buffer.from(psw, 'utf8').toString('hex');
        const key = iv + secret + globalSecret;
        // const key = crypto.scryptSync(secret, iv, 32) // salt
        console.log('secret', secret);
        console.log('key', key);
        try {
            const decyptedData = crypto.AES.decrypt(hash, key).toString(crypto.enc.Utf8);
            console.log('decyptedData', decyptedData);
            return decyptedData;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    saveWallet(param) {
        return (this._storage.save('iv', param.iv)
            && this._storage.save('hash', param.hashFromKey)
            && this._storage.save('public', param.publicKey)
            && this._storage.save('address', param.address));
    }
    // public saveAddress (newAddress: string): boolean {
    //     return (
    //         this._storage.save('address', newAddress)
    //     )
    // }
    async changeVersionAddres(version) {
        console.log('START CHANGE ADDRES TO OTHER VERSION');
        const currentPublic = await this._storage.get('public');
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: Buffer.from(currentPublic, 'hex') });
        if (version === 'V3R1') {
            console.log('START WALLET V3R1');
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: Buffer.from(currentPublic, 'hex') });
        }
        if (version === 'V3R2') {
            console.log('START WALLET V3R2');
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: Buffer.from(currentPublic, 'hex') });
        }
        const newAddress = wallet.address.toString({ bounceable: false });
        return (this._storage.save('address', newAddress));
    }
    // V4, V3R1, V3R2
    saveVersion(param) {
        return (this._storage.save('version', param.version));
    }
    // public async deleteVersion (): Promise<boolean> {
    //     try {
    //         this._storage.del('version')
    //         return true
    //     } catch (error) {
    //         console.error(error)
    //         return false
    //     }
    // }
    // V4, V3R1, V3R2
    async loadVersionSaveData() {
        const savedVersion = await this._storage.get('version');
        console.log('LOAD savedVersion', savedVersion);
        if (!savedVersion || savedVersion.length === 0 || (savedVersion !== 'V4' && savedVersion !== 'V3R1' && savedVersion !== 'V3R2')) {
            console.log('version in storage emptry');
            this.saveVersion({ version: 'V4' });
            return ({ version: 'V4' });
        }
        return { version: savedVersion };
    }
    async loadHashSaveData() {
        return {
            iv: await this._storage.get('iv'),
            hash: await this._storage.get('hash'),
            public: await this._storage.get('public'),
            address: await this._storage.get('address')
        };
    }
    async isSaveWallet() {
        return !!((await this._storage.get('iv')) && (await this._storage.get('hash')));
    }
    async isPincodPassword() {
        return !!((await this._storage.get('isPincode')));
    }
    setIsPincode() {
        return (this._storage.save('isPincode', 'true'));
    }
    async delWallet(psw) {
        const loadData = await this.loadHashSaveData();
        const privateKey = CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        try {
            // const wall = await this.getWalletFromMnemonic(privateKey.split(' '))
            const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
            let wall;
            if (isMnem) {
                console.log('IS ton MNEM');
                wall = await this.getWalletFromMnemonic(privateKey.split(' '));
            }
            else {
                console.log('IS trust MNEM');
                wall = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
            }
            if (wall.address) {
                this._storage.del('iv');
                this._storage.del('hash');
                this._storage.del('public');
                this._storage.del('address');
                return true;
            }
            return false;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    async exitWallet() {
        try {
            this._storage.del('iv');
            this._storage.del('hash');
            this._storage.del('public');
            this._storage.del('address');
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    static sendJettonToBoc(tr, addressUser) {
        const transJetton = {
            queryId: 1,
            tokenAmount: BigInt(tr.amount),
            to: ton_1.Address.parse(tr.to.toString()),
            responseAddress: ton_1.Address.parse(addressUser.toString()),
            comment: tr.comment
        };
        const boc = jetton_1.TokenWallet.buildTransferMessage(transJetton);
        const base64 = boc.toBoc().toString('base64');
        console.log('base64:', base64);
        return base64;
    }
    static sendNFTToBoc(addressTo, addressUser, message) {
        const boc = jetton_1.TokenWallet.buildNFTTransferMessage(addressTo, addressUser, message);
        const base64 = boc.toBoc().toString('base64');
        console.log('base64:', base64);
        return base64;
    }
    // swap
    async SwapTonToJetton(psw, tokenAddress, tonAmountIn) {
        const tonClient = this.client;
        // https://mainnet-v4.tonhubapi.com
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        let CustomWalletData;
        if (isMnem) {
            console.log('IS ton MNEM');
            CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            CustomWalletData = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        // const CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '))
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        const jetton = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress)));
        const pool = tonClient.open(sdk_1.Pool.createFromAddress(await factory.getPoolAddress({
            poolType: sdk_1.PoolType.VOLATILE,
            assets: [sdk_1.Asset.native(), sdk_1.Asset.jetton(jetton.address)]
        })));
        const nativeVault = tonClient.open(sdk_1.VaultNative.createFromAddress(await factory.getVaultAddress(sdk_1.Asset.native())));
        const lastBlock = await tonClient.getLastBlock();
        const poolState = await tonClient.getAccountLite(lastBlock.last.seqno, pool.address);
        const vaultState = await tonClient.getAccountLite(lastBlock.last.seqno, nativeVault.address);
        const amountIn = (0, ton_1.toNano)(tonAmountIn); // ton swap amount
        const DeWalletFee = (0, ton_1.toNano)(Number(tonAmountIn) * 0.01); // ton swap amount
        const { amountOut: expectedAmountOut } = await pool.getEstimatedSwapOut({
            assetIn: sdk_1.Asset.native(),
            amountIn
        });
        // Slippage handling (1%)
        const minAmountOut = (expectedAmountOut * 99n) / 100n; // expectedAmountOut - 1%
        try {
            if (poolState.account.state.type !== 'active') {
                throw new Error('Pool is not exist.');
            }
            if (vaultState.account.state.type !== 'active') {
                throw new Error('Native Vault is not exist.');
            }
            const swapBody = jetton_1.TokenWallet.buildSwapMessageTonToJetton({
                amount: amountIn,
                poolAddress: pool.address,
                limit: minAmountOut
            });
            // await nativeVault.sendSwap(Sender, {
            //     poolAddress: pool.address,
            //     amount: amountIn,
            //     limit: minAmountOut,
            //     gasAmount: toNano('0.25')
            // })
            await this.sendSwapMessageWithFee({
                publicKey: CustomWalletData.publicKey,
                secretKey: CustomWalletData.secretKey,
                Swapfee: DeWalletFee,
                amountIn,
                swapBody,
                contractAddress: nativeVault.address,
                contractDedustFee: (0, ton_1.toNano)('0.25')
            });
        }
        catch (err) {
            console.error(err);
            return false;
        }
        return true;
    }
    // swap jettons without routing
    async GetEstimatedWithoutRouting(tokenName1, tokenName2, tokenAmount1, tokenAddress1, tokenAddress2, decimals1, decimals2) {
        if (tokenAmount1 === '0' || tokenAmount1 === '0.') {
            return '0';
        }
        if (tokenAmount1 === '') {
            return '';
        }
        const tonClient = this.client;
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        const jetton1Root = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress1)));
        const jetton2Root = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress2)));
        const amountIn = BigInt(Number(tokenAmount1) * (10 ** decimals1));
        const poolJettons = tonClient.open(sdk_1.Pool.createFromAddress(await factory.getPoolAddress({
            poolType: sdk_1.PoolType.VOLATILE,
            assets: [sdk_1.Asset.jetton(jetton1Root.address), sdk_1.Asset.jetton(jetton2Root.address)]
        })));
        const { amountOut: expectedAmountOut } = await poolJettons.getEstimatedSwapOut({
            assetIn: sdk_1.Asset.jetton(jetton1Root.address),
            amountIn
        });
        const numberValue = Number(expectedAmountOut) / (10 ** decimals2);
        return (0, formatNumber_1.formatNumber)(String(numberValue));
        // return amountOut
        // return ''
    }
    async SwapJettonsWithoutRouting(psw, tokenAddress, tokenAddress2, jettonAmountIn, deWallFee, decimals) {
        const tonClient = this.client;
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        let CustomWalletData;
        if (isMnem) {
            console.log('IS ton MNEM');
            CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            CustomWalletData = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        const currentSenderAddres = ton_1.Address.parse(CustomWalletData.address);
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        const jetton1Vault = tonClient.open(await factory.getJettonVault(ton_1.Address.parse(tokenAddress)));
        const jetton1Root = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress)));
        const jetton2Root = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress2)));
        const jetton1Wallet = tonClient.open(await jetton1Root.getWallet(currentSenderAddres));
        const amountIn = BigInt(Number(jettonAmountIn) * (10 ** decimals));
        const poolJettons = tonClient.open(sdk_1.Pool.createFromAddress(await factory.getPoolAddress({
            poolType: sdk_1.PoolType.VOLATILE,
            assets: [sdk_1.Asset.jetton(jetton1Root.address), sdk_1.Asset.jetton(jetton2Root.address)]
        })));
        // await jetton1Wallet.sendTransfer(sender, toNano("0.3"), {
        //     amount: amountIn,
        //     destination: scaleVault.address,
        //     responseAddress: sender.address, // return gas to user
        //     forwardAmount: toNano("0.25"),
        //     forwardPayload: VaultJetton.createSwapPayload({ poolAddress }),
        //   });
        const lastBlock = await tonClient.getLastBlock();
        const poolState = await tonClient.getAccountLite(lastBlock.last.seqno, poolJettons.address);
        const vaultState = await tonClient.getAccountLite(lastBlock.last.seqno, poolJettons.address);
        const { amountOut: expectedAmountOut } = await poolJettons.getEstimatedSwapOut({
            assetIn: sdk_1.Asset.jetton(jetton1Root.address),
            amountIn
        });
        const minAmountOut = (expectedAmountOut * 99n) / 100n; // expectedAmountOut - 1%
        try {
            if (poolState.account.state.type !== 'active') {
                throw new Error('Pool is not exist.');
            }
            if (vaultState.account.state.type !== 'active') {
                throw new Error('Jetton Vault is not exist.');
            }
            const swapBody = jetton_1.TokenWallet.buildSwapMessageJettonWallet({
                amount: amountIn,
                destination: jetton1Vault.address,
                responseAddress: currentSenderAddres,
                forwardAmount: (0, ton_1.toNano)('0.25'),
                forwardPayload: sdk_1.VaultJetton.createSwapPayload({ poolAddress: poolJettons.address, limit: minAmountOut })
            });
            await this.sendSwapMessageWithFee({
                publicKey: CustomWalletData.publicKey,
                secretKey: CustomWalletData.secretKey,
                Swapfee: deWallFee,
                amountIn: (0, ton_1.toNano)('0.25'),
                swapBody,
                contractAddress: jetton1Wallet.address,
                contractDedustFee: (0, ton_1.toNano)('0.25')
            });
        }
        catch (err) {
            console.error(err);
            return false;
        }
        return true;
    }
    async SwapJettonToTon(psw, tokenAddress, jettonAmountIn, deWallFee, decimals) {
        const tonClient = this.client;
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        // const CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '))
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        let CustomWalletData;
        if (isMnem) {
            console.log('IS ton MNEM');
            CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            CustomWalletData = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        const currentSenderAddres = ton_1.Address.parse(CustomWalletData.address);
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        const scaleVault = tonClient.open(await factory.getJettonVault(ton_1.Address.parse(tokenAddress)));
        const scaleRoot = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress)));
        const scaleWallet = tonClient.open(await scaleRoot.getWallet(currentSenderAddres));
        const amountIn = BigInt(Number(jettonAmountIn) * (10 ** decimals));
        // const amountIn = (jettonName === 'jUSDT' || jettonName === 'oUSDT') ? BigInt(Number(jettonAmountIn) * (10 ** 6)) : toNano(jettonAmountIn) // jetton swap amount
        const poolJetton = tonClient.open(sdk_1.Pool.createFromAddress(await factory.getPoolAddress({
            poolType: sdk_1.PoolType.VOLATILE,
            assets: [sdk_1.Asset.jetton(scaleRoot.address), sdk_1.Asset.native()]
        })));
        const lastBlock = await tonClient.getLastBlock();
        const poolState = await tonClient.getAccountLite(lastBlock.last.seqno, poolJetton.address);
        const vaultState = await tonClient.getAccountLite(lastBlock.last.seqno, scaleWallet.address);
        const { amountOut: expectedAmountOut } = await poolJetton.getEstimatedSwapOut({
            assetIn: sdk_1.Asset.jetton(scaleRoot.address),
            amountIn
        });
        const minAmountOut = (expectedAmountOut * 99n) / 100n; // expectedAmountOut - 1%
        try {
            if (poolState.account.state.type !== 'active') {
                throw new Error('Pool is not exist.');
            }
            if (vaultState.account.state.type !== 'active') {
                throw new Error('Jetton Vault is not exist.');
            }
            const swapBody = jetton_1.TokenWallet.buildSwapMessageJettonWallet({
                amount: amountIn,
                destination: scaleVault.address,
                responseAddress: currentSenderAddres,
                forwardAmount: (0, ton_1.toNano)('0.25'),
                forwardPayload: sdk_1.VaultJetton.createSwapPayload({ poolAddress: poolJetton.address, limit: minAmountOut })
            });
            await this.sendSwapMessageWithFee({
                publicKey: CustomWalletData.publicKey,
                secretKey: CustomWalletData.secretKey,
                Swapfee: deWallFee,
                amountIn: (0, ton_1.toNano)('0.25'),
                swapBody,
                contractAddress: scaleWallet.address,
                contractDedustFee: (0, ton_1.toNano)('0.25')
            });
            // await scaleWallet.sendTransfer(Sender, toNano('0.3'), {
            //     amount: amountIn,
            //     destination: scaleVault.address,
            //     responseAddress: currentSenderAddres, // return gas to user
            //     forwardAmount: toNano('0.25'),
            //     forwardPayload: VaultJetton.createSwapPayload({ poolAddress: poolJetton.address, limit: minAmountOut })
            // })
        }
        catch (err) {
            console.error(err);
            return false;
        }
        return true;
    }
    async SwapJettonToJetton(psw, tokenAddress1, tokenAddress2, jettonAmountIn, deWallFee, decimals) {
        const tonClient = this.client;
        const loadData = await this.loadHashSaveData();
        const privateKey = await CustomWallet.HashToKey(psw, loadData.iv, loadData.hash);
        if (!privateKey) {
            return false;
        }
        // const CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '))
        const isMnem = await (0, ton_crypto_1.mnemonicValidate)(privateKey.split(' '));
        let CustomWalletData;
        if (isMnem) {
            console.log('IS ton MNEM');
            CustomWalletData = await this.getWalletFromMnemonic(privateKey.split(' '));
        }
        else {
            console.log('IS trust MNEM');
            CustomWalletData = await this.getWalletFromTrustMnemonic(privateKey.split(' '));
        }
        const currentSenderAddres = ton_1.Address.parse(CustomWalletData.address);
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        const jetton1Vault = tonClient.open(await factory.getJettonVault(ton_1.Address.parse(tokenAddress1)));
        const jettonRoot = tonClient.open(sdk_1.JettonRoot.createFromAddress(ton_1.Address.parse(tokenAddress1)));
        const jettonWallet = tonClient.open(await jettonRoot.getWallet(currentSenderAddres));
        const amountIn = BigInt(Number(jettonAmountIn) * (10 ** decimals));
        // const amountIn = (jettonName === 'jUSDT' || jettonName === 'oUSDT') ? BigInt(Number(jettonAmountIn) * (10 ** 6)) : toNano(jettonAmountIn) // jetton swap amount
        const JETTON1 = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress1));
        const TON = sdk_1.Asset.native();
        const JETTON2 = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress2));
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const TON_JETTON1_Pool = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON1]));
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const TON_JETTON2_Pool = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON2]));
        const lastBlock = await tonClient.getLastBlock();
        const poolState = await tonClient.getAccountLite(lastBlock.last.seqno, TON_JETTON1_Pool.address);
        const vaultState = await tonClient.getAccountLite(lastBlock.last.seqno, jettonWallet.address);
        const poolState2 = await tonClient.getAccountLite(lastBlock.last.seqno, TON_JETTON2_Pool.address);
        const vaultState2 = await tonClient.getAccountLite(lastBlock.last.seqno, jettonWallet.address);
        const { amountOut: expectedAmountOut1 } = await TON_JETTON1_Pool.getEstimatedSwapOut({
            assetIn: JETTON1,
            amountIn
        });
        // const { amountOut: expectedAmountOut2 } = await TON_JETTON2_Pool.getEstimatedSwapOut({
        //     assetIn: Asset.native(),
        //     amountIn: expectedAmountOut1,
        // })
        const minAmountOut = (expectedAmountOut1 * 99n) / 100n; // expectedAmountOut - 1% slippage
        try {
            if (poolState.account.state.type !== 'active') {
                throw new Error('Pool is not exist.');
            }
            if (vaultState.account.state.type !== 'active') {
                throw new Error('Jetton Vault is not exist.');
            }
            if (poolState2.account.state.type !== 'active') {
                throw new Error('Pool is not exist.');
            }
            if (vaultState2.account.state.type !== 'active') {
                throw new Error('Jetton Vault is not exist.');
            }
            const swapBody = jetton_1.TokenWallet.buildSwapMessageJettonWallet({
                amount: amountIn,
                destination: jetton1Vault.address,
                responseAddress: currentSenderAddres,
                forwardAmount: (0, ton_1.toNano)('0.25'),
                forwardPayload: sdk_1.VaultJetton.createSwapPayload({
                    poolAddress: TON_JETTON1_Pool.address,
                    limit: minAmountOut,
                    next: { poolAddress: TON_JETTON2_Pool.address } // next step: TON -> BOLT
                })
            });
            await this.sendSwapMessageWithFee({
                publicKey: CustomWalletData.publicKey,
                secretKey: CustomWalletData.secretKey,
                Swapfee: deWallFee,
                amountIn: (0, ton_1.toNano)('0.25'),
                swapBody,
                contractAddress: jettonWallet.address,
                contractDedustFee: (0, ton_1.toNano)('0.25')
            });
            // await jettonWallet.sendTransfer(Sender, toNano('0.3'), {
            //     amount: amountIn,
            //     destination: jetton1Vault.address,
            //     responseAddress: currentSenderAddres, // return gas to user
            //     forwardAmount: toNano('0.25'),
            //     forwardPayload: VaultJetton.createSwapPayload({
            //         poolAddress: TON_JETTON1_Pool.address,
            //         limit: minAmountOut,
            //         next: { poolAddress: TON_JETTON2_Pool.address } // next step: TON -> BOLT
            //     })
            // })
        }
        catch (err) {
            console.error(err);
            return false;
        }
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    async GetEstimatedSwapOut(tokenName1, tokenName2, tokenAmount1, tokenAddress1, tokenAddress2, decimals1, decimals2) {
        if (tokenAmount1 === '0' || tokenAmount1 === '0.') {
            return '0';
        }
        if (tokenAmount1 === '') {
            return '';
        }
        const tonClient = this.client;
        const factory = tonClient.open(sdk_1.Factory.createFromAddress(sdk_1.MAINNET_FACTORY_ADDR));
        if (tokenName1 === 'TON' && tokenName2 !== 'TON') {
            const JETTON = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress2));
            const TON = sdk_1.Asset.native();
            const PoolTonToJetton = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON]));
            const { amountOut: expectedAmountOutTonToJetton } = await PoolTonToJetton.getEstimatedSwapOut({
                assetIn: TON,
                amountIn: (0, ton_1.toNano)(tokenAmount1)
            });
            // const numberValue: number = Number(expectedAmountOutTonToJetton) / 1e9
            console.log('SWAP OUT expectedAmountOutTonToJetton', expectedAmountOutTonToJetton);
            const numberValue = Number(expectedAmountOutTonToJetton) / (10 ** decimals2); // Number(fromNano(expectedAmountOutTonToJetton))
            // if (tokenName2 === 'jUSDT' || tokenName2 === 'oUSDT') {
            //     // numberValue *= 1000
            //     numberValue = Number(expectedAmountOutTonToJetton) / (10 ** 6)
            // }
            console.log('numberValue before formating', numberValue);
            return (0, formatNumber_1.formatNumber)(String(numberValue));
        }
        if (tokenName1 !== 'TON' && tokenName2 === 'TON') {
            const JETTON = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress1));
            const TON = sdk_1.Asset.native();
            const PoolJettonToTon = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON]));
            const { amountOut: expectedAmountOutJettonToTon } = await PoolJettonToTon.getEstimatedSwapOut({
                assetIn: JETTON,
                amountIn: BigInt(Number(tokenAmount1) * (10 ** decimals1))
            });
            const numberValue = Number((0, ton_1.fromNano)(expectedAmountOutJettonToTon));
            // if (tokenName1 === 'jUSDT' || tokenName1 === 'oUSDT') {
            //     numberValue = Number(expectedAmountOutJettonToTon) / (10 ** 6)
            // }
            return (0, formatNumber_1.formatNumber)(String(numberValue));
        }
        if (tokenName1 !== 'TON' && tokenName2 !== 'TON') {
            const JETTON1 = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress1));
            const TON = sdk_1.Asset.native();
            const JETTON2 = sdk_1.Asset.jetton(ton_1.Address.parse(tokenAddress2));
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const TON_JETTON1_Pool = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON1]));
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const TON_JETTON2_Pool = tonClient.open(await factory.getPool(sdk_1.PoolType.VOLATILE, [TON, JETTON2]));
            const { amountOut: expectedAmountOut1 } = await TON_JETTON1_Pool.getEstimatedSwapOut({
                assetIn: JETTON1,
                amountIn: BigInt(Number(tokenAmount1) * (10 ** decimals1))
            });
            const { amountOut: expectedAmountOut2 } = await TON_JETTON2_Pool.getEstimatedSwapOut({
                assetIn: sdk_1.Asset.native(),
                amountIn: expectedAmountOut1
            });
            console.log('BIGINT JETTON2', expectedAmountOut2);
            const numberValue = Number(expectedAmountOut2) / (10 ** decimals2);
            return (0, formatNumber_1.formatNumber)(String(numberValue));
        }
        return '';
    }
    async sendSwapMessageWithFee({ publicKey, secretKey, Swapfee, amountIn, swapBody, contractAddress, contractDedustFee }) {
        const loadData = await this.loadVersionSaveData();
        let wallet = ton_1.WalletContractV4.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        if (loadData.version === 'V3R1') {
            wallet = ton_1.WalletContractV3R1.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        if (loadData.version === 'V3R2') {
            wallet = ton_1.WalletContractV3R2.create({ workchain, publicKey: Buffer.from(publicKey, 'hex') });
        }
        const contract = this.client.open(wallet);
        const seqno = await contract.getSeqno();
        console.log('INIT SEQNO', seqno);
        // const balance: bigint = await contract.getBalance()
        // if (balance < toNano('0.0001') + fee) {
        //     console.error('balance < toNano(0.0001) + fee')
        //     return false
        // }
        // if (balance < (Swapfee + contractDedustFee + amountIn)) {
        //     console.error('balance error')
        //     console.log('Swapfee', Swapfee)
        //     console.log('contractDedustFee', contractDedustFee)
        //     console.log('amountIn', amountIn)
        //     console.log('balance', balance)
        //     return false
        // }
        // if (!Address.parse(trans.to).toString()) {
        //     console.error('error address to address')
        //     return false
        // }
        // console.log('trans', trans)
        // console.log('seqno', seqno)
        // console.log('secretKey', secretKey)
        // console.log('FINAL SEQNO', seqno)
        const msgs = [
            (0, ton_1.internal)({
                value: Swapfee,
                to: ton_1.Address.parse('UQAD5kUV1BmSaC6ElEYL5X-Nwc64zYDt14LwyTt20XjyjoM_'),
                bounce: false,
                body: (0, ton_1.comment)('fee'),
                init: wallet.init
            }),
            (0, ton_1.internal)({
                value: contractDedustFee + amountIn,
                to: contractAddress,
                bounce: true,
                body: swapBody,
                init: wallet.init
            })
        ];
        const tr = contract.createTransfer({
            seqno,
            secretKey: Buffer.from(secretKey, 'hex'),
            sendMode: 1,
            messages: msgs
        });
        try {
            await contract.send(tr);
        }
        catch (err) {
            console.error(err);
            return false;
        }
        return true;
    }
    async isAuth() {
        const iv = await this._storage.get('iv');
        const hash = await this._storage.get('hash');
        const publicKey = await this._storage.get('public');
        const address = await this._storage.get('address');
        if (!iv || !hash || !publicKey || !address) {
            return false;
        }
        return true;
    }
}
exports.CustomWallet = CustomWallet;
